
import React from "react";
import { cn } from "@/lib/utils";

interface TimelineProps {
  children: React.ReactNode;
  className?: string;
}

export function Timeline({ children, className }: TimelineProps) {
  return (
    <div className={cn("relative space-y-6", className)}>
      {children}
    </div>
  );
}

interface TimelineItemProps {
  children: React.ReactNode;
  className?: string;
}

export function TimelineItem({ children, className }: TimelineItemProps) {
  return (
    <div className={cn("relative pl-8", className)}>
      <div className="absolute left-0 top-1.5 h-3 w-3 rounded-full bg-blog-neon shadow-[0_0_6px_rgba(67,255,255,0.8)]"></div>
      <div className="absolute left-1.5 top-6 h-full w-px bg-border"></div>
      <div className="glass-card p-4 border-futuristic-border/40 hover:shadow-[0_0_15px_rgba(67,255,255,0.2)] transition-shadow">
        {children}
      </div>
    </div>
  );
}
